import {
  USER_ALLOWED_ACTION_STORAGE_KEY,
  USER_RIGHTS_STORAGE_KEY,
} from "pages/constants/StorageKeys";
import {
  getLocalStorageItem,
  setLocalStorageItem,
} from "pages/Hooks/useLocalStorage";

export function SetUserRights(userRights: any) {
  setLocalStorageItem(USER_RIGHTS_STORAGE_KEY, userRights);
  SetUserAllowedActions(userRights);
}

export function GetUserRights() {
  const data = getLocalStorageItem(USER_RIGHTS_STORAGE_KEY);
  return data ? data : {};
}

function SetUserAllowedActions(userRights: Record<string, Array<string>>) {
  const allowedActions: Array<string> = [];
  for (let source in userRights) {
    userRights[source].forEach((action: string) => {
      allowedActions.push(source + "_" + action);
    });
  }
  setLocalStorageItem(USER_ALLOWED_ACTION_STORAGE_KEY, allowedActions);
}

export function hasRight(action: string) {
  const storedActions = getLocalStorageItem(USER_ALLOWED_ACTION_STORAGE_KEY);
  if (storedActions) {
    const userActions = storedActions;
    return userActions.includes(action);
  }
  return false;
}
